import instance from "./Instance/index.js";

export const createUser = async (values) => {
  try {
    const response = await instance.post(`/users`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const authenticateUser = async (values) => {
  try {
    const response = await instance.post(`/users/authenticate`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getUsers = async () => {
  try {
    const response = await instance.get(`/users`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getUsersInfo = async () => {
  try {
    const response = await instance.get(`/users/usersInfo`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getUser = async (id) => {
  try {
    const response = await instance.get(`/users/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const searchUser = async (values) => {
  try {
    const response = await instance.post(`/users/search`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const updateUser = async (id, values) => {
  try {
    const response = await instance.patch(`/users/update/${id}`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const updateRating = async (values) => {
  try {
    const response = await instance.patch(`/users/rating`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const verifyUser = async (id) => {
  try {
    const response = await instance.put(`/users/verify/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await instance.delete(`/users/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const resetPassword = async (values) => {
  try {
    const response = await instance.post(`/users/reset-password/`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const setPassword = async (values) => {
  try {
    const response = await instance.post(`/users/reset-password/`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const verifyToken = async (values) => {
  try {
    const response = await instance.post(`/users/verify-token/`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const contact = async (values) => {
  try {
    const response = await instance.post(`/users/contact-us`, values);
    return response;
  } catch (err) {
    throw err;
  }
};